"use client";

import { isBackendConfigured } from "@/api/api-client";
import { fetchAztangofestBookingSessionMe } from "@/api/aztangofest/fetchAztangofestBookingSessionMe";
import {
  getAzDanceBookingToken,
  isAzDanceBookingTokenValid,
} from "@/lib/azdanceBookingSession";
import {
  handleAzDanceBookingUnauthorized,
  isAzDanceBookingApiUnauthorized,
} from "@/lib/azdanceBookingAuth";
import { syncAzDanceBookingTokenFromCookie } from "@/lib/azdanceBookingTokenSync";
import { useRegistrationStore } from "@/state/stores/registrationStore";

/**
 * GET `/azdance/profile/me` и запись `dashboardEventBookingId` + владелец сессии в стор.
 * Без рекапчи; только при валидной куке JWT.
 */
export async function applyBookingSessionMeToStore(
  language: string,
): Promise<void> {
  if (typeof window === "undefined" || !isBackendConfigured()) return;
  syncAzDanceBookingTokenFromCookie();
  const token = getAzDanceBookingToken();
  if (!token?.trim() || !isAzDanceBookingTokenValid()) return;
  try {
    const me = await fetchAztangofestBookingSessionMe(language, token);
    const pid = (me.id ?? "").trim();
    const eid = me.eventBookingId?.trim() || null;
    if (pid) {
      const { currentUser, setCabinetOwnerParticipantId } =
        useRegistrationStore.getState();
      if (!currentUser || currentUser.id === pid) {
        setCabinetOwnerParticipantId(pid);
      }
    }
    useRegistrationStore.getState().setDashboardEventBookingId(eid);
  } catch (err) {
    if (isAzDanceBookingApiUnauthorized(err)) {
      handleAzDanceBookingUnauthorized("api_unauthorized");
    }
  }
}
